export const environment = {
  friendsPaymentBaseUrl: 'https://api.split-panas.unimagen.ovh/fp',
  keycloakUrl: 'https://auth.unimagen.ovh/',
  realm: 'friends-payment',
  clientId: 'friendspayment'
};
